export const COMENTARIO_OBSERVACION_LOADING = 'COMENTARIO_OBSERVACION_LOADING';
export const COMENTARIO_OBSERVACION_LOADED = 'COMENTARIO_OBSERVACION_LOADED';
export const COMENTARIO_OBSERVACION_ERROR = 'COMENTARIO_OBSERVACION_ERROR';

export const OBSERVACION_USER_LOADING = 'OBSERVACION_USER_LOADING';
export const OBSERVACION_USER_LOADED = 'OBSERVACION_USER_LOADED';
export const OBSERVACION_USER_ERROR = 'OBSERVACION_USER_ERROR';

export const OBSERVACION_DEX_LOADING = 'OBSERVACION_DEX_LOADING';
export const OBSERVACION_DEX_LOADED = 'OBSERVACION_DEX_LOADED';
export const OBSERVACION_DEX_ERROR = 'OBSERVACION_DEX_ERROR';

export const OBSERVACION_HOME_LOADING = 'OBSERVACION_HOME_LOADING';
export const OBSERVACION_HOME_LOADED = 'OBSERVACION_HOME_LOADED';
export const OBSERVACION_HOME_ERROR = 'OBSERVACION_HOME_ERROR';

export const OBSERVACION_HOMEMAPA_LOADING = 'OBSERVACION_HOMEMAPA_LOADING';
export const OBSERVACION_HOMEMAPA_LOADED = 'OBSERVACION_HOMEMAPA_LOADED';
export const OBSERVACION_HOMEMAPA_ERROR = 'OBSERVACION_HOMEMAPA_ERROR';

export const OBSERVACION_INDIVIDUAL_EXPLORAR_ERROR = 'OBSERVACION_INDIVIDUAL_EXPLORAR_ERROR';
export const OBSERVACION_INDIVIDUAL_EXPLORAR_LOADED = 'OBSERVACION_INDIVIDUAL_EXPLORAR_LOADED';
export const OBSERVACION_INDIVIDUAL_EXPLORAR_LOADING = 'OBSERVACION_INDIVIDUAL_EXPLORAR_LOADING';

export const IDENTIFICACION_OBSERVACION_LOADING = 'IDENTIFICACION_OBSERVACION_LOADING';
export const IDENTIFICACION_OBSERVACION_LOADED = 'IDENTIFICACION_OBSERVACION_LOADED';
export const IDENTIFICACION_OBSERVACION_ERROR = 'IDENTIFICACION_OBSERVACION_ERROR';

export const TAXO_OBSERVACION_LOADING = 'TAXO_OBSERVACION_LOADING';
export const TAXO_OBSERVACION_LOADED = 'TAXO_OBSERVACION_LOADED';
export const TAXO_OBSERVACION_ERROR = 'TAXO_OBSERVACION_ERROR';

export const CREAR_OBSERVACION_LOADING = 'CREAR_OBSERVACION_LOADING';
export const CREAR_OBSERVACION_LOADED = 'CREAR_OBSERVACION_LOADED';
export const CREAR_OBSERVACION_ERROR = 'CREAR_OBSERVACION_ERROR';
export const RESET_OBSERVACION_STATE = 'RESET_OBSERVACION_STATE';
export const RESET_EDITOBSERVACION_STATE = 'RESET_EDITOBSERVACION_STATE';

export const EDITAR_OBSERVACION_LOADING = 'EDITAR_OBSERVACION_LOADING';
export const EDITAR_OBSERVACION_LOADED = 'EDITAR_OBSERVACION_LOADED';
export const EDITAR_OBSERVACION_ERROR = 'EDITAR_OBSERVACION_ERROR';

export const OBSERVACION_INDI_LOADING = 'OBSERVACION_INDI_LOADING';
export const OBSERVACION_INDI_LOADED = 'OBSERVACION_INDI_LOADED';
export const OBSERVACION_MAPA_LOADED  = 'OBSERVACION_MAPA_LOADED ';
export const OBSERVACION_INDI_ERROR = 'OBSERVACION_INDI_ERROR';

export const OBSERVACION_EXPLORAR_ERROR = 'OBSERVACION_EXPLORAR_ERROR';
export const OBSERVACION_EXPLORAR_LOADED = 'OBSERVACION_EXPLORAR_LOADED';
export const OBSERVACION_EXPLORAR_LOADING = 'OBSERVACION_EXPLORAR_LOADING';
export const OBSERVACION_EXPLORAR_MAPA_LOADED  = 'OBSERVACION_EXPLORAR_MAPA_LOADED';

export const OBSERVACION_PROYECTO_ERROR = 'OBSERVACION_PROYECTO_ERROR';
export const OBSERVACION_PROYECTO_LOADED = 'OBSERVACION_PROYECTO_LOADED';
export const OBSERVACION_PROYECTO_LOADING = 'OBSERVACION_PROYECTO_LOADING';
export const OBSERVACION_PROYECTO_MAPA_LOADED  = 'OBSERVACION_PROYECTO_MAPA_LOADED';

export const DELETE_OBSERVACION_LOADING = 'DELETE_OBSERVACION_LOADING';
export const DELETE_OBSERVACION_LOADED = 'DELETE_OBSERVACION_LOADED';
export const DELETE_OBSERVACION_ERROR  = 'DELETE_OBSERVACION_ERROR';
